import React from 'react';

import { toSimpleUtcDateString } from 'src/utils/format/date';
import s from './TimelineProgressBar.styles';

const TimelineProgressBar = ({
  startDate,
  completionDate, 
  label,
  startDateLabel,
  completionDateLabel,
  isDefaultState = true,
  isInProgress = false,
  hasDelay = false,
  daysDelay,
  completionDateReal,
  isCompleted = false,
}) => {

  return (
    <>
      <s.TimelineProgressBarWrapper data-testid="timeline-progress-bar">
        <div>
          <div className="position-absolute top-[-5px]">
            <s.Label data-testid="start-date-label" isBold>{startDateLabel}</s.Label>
            <s.Label data-testid="start-date">{toSimpleUtcDateString(startDate, 'D MMM YYYY')}</s.Label>
          </div>
          { isDefaultState && !hasDelay && <s.Label data-testid="default-label" className="position-absolute top-[45px]" isBlue isBold>{label}</s.Label>}
          <s.Milestone data-testid="milestone" isAchieved={!isDefaultState || hasDelay} />
        </div>
        <s.ProgressBarWrapper className="position-relative">
          <s.ProgressBar 
            inProgress={isInProgress}  
            hasDelay={hasDelay}
            isCompleted={isCompleted && !hasDelay}
            data-testid="progress-bar"
          />
          { (isInProgress || hasDelay) && (<s.MiddleLabelWrapper data-testid="middle-label-wrapper" className="position-absolute top-[-5px]" >
            <s.Milestone data-testid="middle-milestone" isAchieved={hasDelay} />
            { hasDelay && <s.Label data-testid="delay-label" isRed>{daysDelay} { daysDelay > 1 ? 'days' : 'day' } delay</s.Label> }
            { !hasDelay && <s.Label data-testid="middle-label" isBold isBlue>{label}</s.Label> }
          </s.MiddleLabelWrapper>
          )}
        </s.ProgressBarWrapper>
        <div className="position-relative">
          <s.Milestone 
            isDelayed={hasDelay}
            isNotAchieved={isDefaultState || isInProgress} 
            data-testid="end-milestone"
          />
          <div data-testid="completion-date-wrapper" className={`position-absolute top-[-35px] ${hasDelay ? 'right-[25px]' : ''}`}>
            <s.Label isBold data-testid="completion-date-label">{completionDateLabel}</s.Label>
            <s.Label data-testid="completion-date">{toSimpleUtcDateString(completionDate, 'D MMM YYYY')} - Target</s.Label>
          </div>
          { (hasDelay || isCompleted) && <div data-testid="completion-label-wrapper" className="position-absolute top-[15px]">
            <s.Label data-testid="completion-label" isBold isBlue isRed={hasDelay}>{label}</s.Label>
            { isCompleted && <s.Label data-testid="completion-date-real" isBlue isRed={hasDelay}>{completionDateReal}</s.Label>}
          </div>
          }
        </div>
      </s.TimelineProgressBarWrapper>
    </>
  );

};

export default TimelineProgressBar;
